import { gql } from '@apollo/client';

// ========== QUERIES ==========

export const GET_ADMIN_USERS = gql`
  query AdminUsers($filter: AdminUserFilterInput, $page: Int, $pageSize: Int) {
    adminUsers(filter: $filter, page: $page, pageSize: $pageSize) {
      items {
        id
        email
        firstName
        lastName
        displayName
        username
        slug
        avatarUrl
        jobTitle
        company
        bio
        city
        country
        sector
        profileViews
        verifiedBadge
        isPremium
        accountStatus
        role
        createdAt
        updatedAt
        subscription {
          plan
          status
        }
        cardsCount
      }
      total
      page
      pageSize
    }
  }
`;

export const GET_ADMIN_USER = gql`
  query AdminUser($userId: ID!) {
    adminUser(userId: $userId) {
      id
      email
      firstName
      lastName
      displayName
      username
      slug
      avatarUrl
      jobTitle
      company
      bio
      city
      country
      sector
      profileViews
      verifiedBadge
      isPremium
      accountStatus
      role
      createdAt
      updatedAt
      subscription {
        plan
        status
      }
      cardsCount
    }
  }
`;

export const GET_ADMIN_USER_CARDS = gql`
  query AdminUserCards($userId: ID!) {
    adminUserCards(userId: $userId) {
      id
      slug
      cardType
      displayName
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_ADMIN_USER_STATS = gql`
  query AdminUserStats($userId: ID!) {
    adminUserStats(userId: $userId) {
      profileViews
      totalCards
      totalConnections
      accountAge
      lastUpdated
    }
  }
`;

export const GET_ADMIN_USER_SUBSCRIPTION_HISTORY = gql`
  query AdminUserSubscriptionHistory($userId: ID!) {
    adminUserSubscriptionHistory(userId: $userId)
  }
`;

export const GET_ADMIN_USER_GLOBAL_STATS = gql`
  query AdminUserGlobalStats {
    adminUserGlobalStats {
      total
      active
      suspended
      verified
      newThisMonth
      byRole
    }
  }
`;

// ========== MUTATIONS ==========

export const SUSPEND_USER = gql`
  mutation AdminSuspendUser($userId: ID!, $reason: String) {
    adminSuspendUser(userId: $userId, reason: $reason) {
      id
      accountStatus
    }
  }
`;

export const REACTIVATE_USER = gql`
  mutation AdminReactivateUser($userId: ID!) {
    adminReactivateUser(userId: $userId) {
      id
      accountStatus
    }
  }
`;

export const SET_VERIFIED_BADGE = gql`
  mutation AdminSetVerifiedBadge($userId: ID!, $verified: Boolean!) {
    adminSetVerifiedBadge(userId: $userId, verified: $verified) {
      id
      verifiedBadge
    }
  }
`;

export const SET_USER_ROLE = gql`
  mutation AdminSetUserRole($userId: ID!, $role: UserRole!) {
    adminSetUserRole(userId: $userId, role: $role) {
      id
      role
    }
  }
`;

export const UPDATE_USER = gql`
  mutation AdminUpdateUser($userId: ID!, $input: AdminUserUpdateInput!) {
    adminUpdateUser(userId: $userId, input: $input) {
      id
      firstName
      lastName
      displayName
      email
      jobTitle
      company
      sector
      city
      country
      bio
    }
  }
`;
